// extracted by mini-css-extract-plugin
export default {"wallet":"style_wallet__byD76","content":"style_content__iAITW","customError":"style_customError__QChCJ","bg_main":"style_bg_main__9moJ-","bg_top":"style_bg_top__GbHSZ"};